<template>
  <section class="is-full-screen-height has-background-light-grey is-flex is-flex-direction-column">
    <header class="has-background-white is-flex is-align-items-center px-5 py-4">
      <img :src="logo" alt="ClearEstate" width="156" />
    </header>
    <router-view />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { NavigationGuardNext, Route } from 'vue-router';
import logo from '@/assets/logos/logo.svg';
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';

export default defineComponent({
  name: 'BookingLinkLayout',
  static: {
    logo
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext): void {
    DocumentUIService.removeAppLoader();
    next();
  }
});
</script>
